import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";

export function TabbioVerifiedBadge({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { t } = useTranslation("common");
  return (
    <span
      aria-label={t("skills.verified")}
      title={t("skills.verified")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        color: "var(--text-secondary)",
        fontSize: 12,
        fontWeight: 500,
        flexShrink: 0,
      }}
    >
      <BadgeCheck size={compact ? 14 : 16} fill="currentColor" stroke="var(--bg)" aria-hidden />
      {compact ? null : t("skills.verified")}
    </span>
  );
}
